
import _ from 'lodash';
import { PaginationRestDTO, PaginatedDataDTO, PaginationDTO } from '@bottega52/commons-pagination';
import { ICustomerContractInDTO } from '../repository/jago/model/input/ICustomerContractInDTO';
import { DomainIrisStatusOptions, IDomainInDTO } from '../repository/jago/model/input/IDomainInDTO';
import { IWalletPlantOutDTO } from '../repository/jago/model/output/IWalletPlantOutDTO';
import { ICustomerDomainFormDTO } from '../repository/jago/model/input/IDomainInDTO';

export function decode(data: PaginationRestDTO<ICustomerContractInDTO>): PaginatedDataDTO<ICustomerContractInDTO> {
    const pagination: PaginationDTO = _.omit(data, 'content');
    return {
      content: data.content,
      pagination,
    };
}

export enum CustomerPlantSolutionOptions {
  LSA = 'LSA',
  V364 = 'V364',
  LUCKEY = 'LUCKEY',
  ARGO = 'ARGO',
  FLEX = 'FLEX',
  LWC = 'LWC',
  ATG = 'ATG',
  VAR = 'VAR',
  MECHANIC = 'MECHANIC',
  OTHER = 'OTHER',
}

export enum CustomerPlantPlatformOptions {  
  IRIS = '1RIS',
  IRIS_ARGO = '1RIS_ARGO',
  ARGO = 'ARGO',
}

export enum CustomerPlantTypeOptions {  
  PREPROD_PILOT = 'PREPROD_PILOT',
  PREPROD_PRODUCTION = 'PREPROD_PRODUCTION',
  PROD_PILOT = 'PROD_PILOT',
  PROD_PRODUCTION = 'PROD_PRODUCTION',
  PROD_DISABLED = 'PROD_DISABLED',
  DEMO = 'DEMO',
  DEAD = 'DEAD',
}

export enum CustomerPlantManagementOptions {
  SAAS_AZURE = 'SAAS_AZURE',
  SAAS_AWS = 'SAAS_AWS',
  ON_PREMISE_CLASSIC = 'ON_PREMISE_CLASSIC',
  ON_PREMISE_VM_NATIVE = 'ON_PREMISE_VM_NATIVE',
  ON_PREMISE_VM_DOCKER_BASED = 'ON_PREMISE_VM_DOCKER_BASED',
  ON_PREMISE_CONTAINER = 'ON_PREMISE_CONTAINER',
  ON_PREMISE_OTHER = 'ON_PREMISE_OTHER',
  OTHER = 'OTHER',
}

export enum CustomerPlantModalityOptions {
  PERIODIC = 'PERIODIC',
  CREDITS = 'CREDITS',
}

export function decodeCustomerPlantContentToForm(data: IDomainInDTO): ICustomerDomainFormDTO {
  return {
    id: data.id,
    customerId: data.customerId,
    hostname: data.hostname,
    solution: data.solution,
    management: data.management,
    modality: data.modality,
    subSegment: data.subSegment,
    zenDeskId: data.zenDeskId,
    loginData: data.loginData,
    license1ris: data.license1ris,
    type: data.type,
    platform: data.platform,
    lockbaseId: data.lockbaseId,
    name: data.name,
  };
}

export function encodeCustomerPlantFromForm(data: ICustomerDomainFormDTO): IWalletPlantOutDTO {
    let retVal: IWalletPlantOutDTO = {
      customerId: data.customerId,
      name: data.name,
      enable1ris: DomainIrisStatusOptions.NOT_REQUIRED,
      solution: data.solution,
      management: data.management,
      modality: data.modality,
      subSegment: data.subSegment,
      zenDeskId: data.zenDeskId,
      loginData: data.loginData,
      license1ris: data.license1ris,
      lockbaseId: data.lockbaseId,
      type: data.type,
      platform: data.platform,
      hostname: data.hostname,
    };
    return retVal;
}

export function encodeCustomerPlantInFromOut(data: IDomainInDTO): IWalletPlantOutDTO {
    return {
      customerId: data.customerId,
      enable1ris: data.enable1ris,
      name: data.name,
      solution: data.solution,
      management: data.management,
      modality: data.modality,
      subSegment: data.subSegment,
      zenDeskId: data.zenDeskId,
      loginData: data.loginData,
      license1ris: data.license1ris,
      lockbaseId: data.lockbaseId,
      type: data.type,
      platform: data.platform,
      hostname: data.hostname,
    };
}